import { render, staticRenderFns } from "./EmailMsg.vue?vue&type=template&id=2f48ba13"
import script from "./EmailMsg.vue?vue&type=script&lang=js"
export * from "./EmailMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports